/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */
import * as types from "./types";

const mutations = {
  [types.SET_ENV](state, payload) {
    state.env = payload;
  },
  [types.SET_AUDIENCE_SIZES](state, payload) {
    state.audienceSizes = payload;
  },
  [types.SET_BUCKET_SIZES](state, payload) {
    state.bucketSizes = payload;
  },
  [types.SET_PDM](state, payload) {
    state.pdm = payload;
  },
  [types.SET_CAID](state, payload) {
    state.caid = payload;
  },
  [types.SET_PDM_MODEL](state, payload) {
    state.pdmModel = payload;
  },
  [types.SET_CONFIGURATION](state, payload) {
    state.configuration = { ...state.configuration, ...payload };
  },
  [types.SET_PROPERTY_CONFIGURATION](state, { property, value }) {
    state.configuration = { ...state.configuration, [property]: value };
  },
  [types.SET_AVAILABLE_SWATCHES](state, payload) {
    state.availableSwatches = payload;
  },
  [types.SET_AVAILABLE_STICKERS](state, payload) {
    state.availableStickers = payload;
  },
  [types.SET_AVAILABLE_STICKER_GROUPS](state, payload) {
    state.availableStickersByGroup = payload;
  },
  [types.SET_ACTIVE_COMPONENT](state, payload) {
    state.activeComponent = payload;
  },
  [types.SET_SCREEN_SIZE](state, payload) {
    state.screenSize = payload;
  },
  [types.SET_TRAY_DISABLED_STATUS](state, { element, status }) {
    state.trayDisabled[element] = !!status;
  },
  [types.CHANGE_VISIBILITY_EXTERNAL_HEADERS](state, payload) {
    state.externalHeadersVisible = payload;

    let headerContainer = document.querySelectorAll('div.topnav');
    if (!!headerContainer.length) {
      headerContainer = headerContainer[0];

      if (payload && headerContainer.classList.contains('hide-external-headers')) {
        headerContainer.classList.remove('hide-external-headers');
      } else if (!payload && !headerContainer.classList.contains('hide-external-headers')) {
        headerContainer.classList.add('hide-external-headers');
      }
    }
  },
  [types.SET_BUCKET_SIZE](state, bucketSize) {
    state.bucketSizes = bucketSize;
  },
  [types.SET_MODEL_VIEWS](state, modelViews) {
    state.modelViews = modelViews;
  },
  [types.SET_IS_PRODUCTION](state, data) {
    state.isProduction = data;
  },
  [types.SET_IS_SPLASH_MODAL_OPEN](state, payload) {
    state.isSplashModalOpen = payload;
  },
  [types.SET_IS_DESIGN_TRANSFERING](state, payload) {
    state.isDesignTransfering = payload;
  },
  [types.SET_IS_DESIGN_TRANSFER_APPLIED](state, payload) {
    state.isDesignTransferApplied = payload;
  },
  [types.SET_IS_FINISH_MY_DESIGN_APPLIED](state, payload) {
    state.isFinishMyDesignApplied = payload;
  },
  [types.SET_PATTEN_MAKER_AVAILABLE_CONTENT](state, payload) {
    state.availablePatternMakerContent = payload;
  },
  [types.SET_IS_RANDOMIZE_APPLIED](state, payload) {
    state.isRandomizeApplied = payload;
  },
  [types.SET_QUERY_PARAMS](state, payload) {
    state.queryParams = { 
      ...state.queryParams, 
      ...Object.fromEntries(Object.entries(payload).filter(([key]) => !(key in state.queryParams)))
    }
  },
  /**
   * Set true when occurs an error in a modal.
   */
  [types.SET_ERROR_MODAL_PROCESS](state, payload) {
    state.errorModalProcess = payload;
  },
  /**
   * Set true when os loading the umd package.
   */
  [types.SET_VSF_ACTIVE](state, payload) {
    state.vsfActive = payload;
  },
  [types.SET_INITIAL_TIME](state, payload) {
    state.initialTime = payload;
  },
  [types.SET_WINDOW_WIDTH](state, payload) {
    state.windowWidth = payload;
  },
  [types.SET_RECAPTCHA_PROPERTY](state, { element, data }) {
    state.recaptcha[element] = data;
  },
  //canvas
  [types.SET_HEADERS_DATA](state, payload) {
    state.canvasAPIheaders = {...state.canvasAPIheaders, ...payload};
  },
  [types.SET_USER_AUTH](state, payload) {
    state.canvasAPIheaders.authorization = payload;
  }
};

export default mutations;
